import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DEFAULT_DATE_FORMAT } from '../config';
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);


export const formatUnixTimestamp = (timestamp: number, format: string = DEFAULT_DATE_FORMAT): string => {
  if (!Number.isFinite(timestamp)) return '';
  return dayjs(timestamp * 1000).format(format);
};

/**
 * Format Date objects or date strings (not Unix timestamps)
 * @param date - Date object or date string
 * @param format - The format pattern (default: DEFAULT_DATE_FORMAT)
 * @returns Formatted date string
 */
export const formatDate = (date: Date | string, format: string = DEFAULT_DATE_FORMAT): string => {
  if (!date) return '';
  return dayjs(date).format(format);
};

/**
 * Add days to a date
 * @param date - The base date (timestamp, Date object, or string)
 * @param days - Number of days to add (negative to subtract)
 * @param format - Output format (default: DEFAULT_DATE_FORMAT)
 * @returns Formatted date string
 */
export const addDaysToDate = (date: number | Date | string, days: number, format: string = DEFAULT_DATE_FORMAT): string => {
  if (!date || !Number.isFinite(days)) return '';
  
  if (typeof date === 'number' && Number.isFinite(date)) {
    return dayjs(date * 1000).add(days, 'day').format(format);
  }
  
  return dayjs(date).add(days, 'day').format(format);
};

